<!-- Start Breadcrumbs -->
<app-breadcrumbs
  title="{{ 'PIPEDRIVE.TITLE' | translate }}"
  [breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<form [formGroup]="pipedriveForm" (ngSubmit)="Submit($event)">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <div class="row mb-3">
          <div class="col-lg-8">
            <label class="form-label" for="base-url-input">
              {{ "PIPEDRIVE.URL_BASE" | translate }}
              <app-required-field></app-required-field>
            </label>
            <input
              type="text"
              class="form-control"
              id="base-url-input"
              formControlName="baseUrl"
              placeholder="https://profitsconsulting.pipedrive.com"
            />
          </div>
          <div class="col-lg-4">
            <label class="form-label" for="api-path-input">
              {{ "PIPEDRIVE.API_PATH" | translate }}
              <app-required-field></app-required-field>
            </label>
            <input
              type="text"
              class="form-control"
              id="api-path-input"
              formControlName="apiPath"
              placeholder="/api/v2"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label class="form-label" for="api-token-input">
              {{ "PIPEDRIVE.API_TOKEN" | translate }}
              <app-required-field></app-required-field>
            </label>
            <input
              type="text"
              class="form-control"
              id="api-token-input"
              formControlName="apiToken"
              placeholder="{{ 'PIPEDRIVE.API_TOKEN' | translate }}"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label class="form-label" for="licenseflow-input">
              {{ "PIPEDRIVE.LICENSEFLOW" | translate }}
              <app-required-field></app-required-field>
            </label>
            <select
              class="form-select"
              id="licenseflow-input"
              formControlName="licenseFlowId"
              *ngIf="isUpdating && hasFlows"
            >
              <option value="">{{ "SELECT" | translate }}</option>
              <option
                *ngFor="let flow of allFlows"
                [value]="flow.id"
              >
                {{ flow.name }}
              </option>
            </select>
            <input type="text" class="form-control" [disabled]="!isUpdating" *ngIf="!isUpdating" [value]="f['licenseFlowName'].value" />
          </div>
          <div class="col-6">
            <label class="form-label" for="hostflow-input">
              {{ "PIPEDRIVE.HOSTFLOW" | translate }}
              <app-required-field></app-required-field>
            </label>
            <select
              class="form-select"
              id="hostflow-input"
              formControlName="hostFlowId"
              *ngIf="isUpdating && hasFlows"
            >
              <option value="">{{ "SELECT" | translate }}</option>
              <option
                *ngFor="let flow of allFlows"
                [value]="flow.id"
              >
                {{ flow.name }}
              </option>
            </select>
            <input type="text" class="form-control" [disabled]="!isUpdating" *ngIf="!isUpdating" [value]="f['hostFlowName'].value" />
          </div>
        </div>
        <!-- end card body -->
      </div>
    </div>
    <!-- end card -->

    <div class="text-end mb-4">
      
      <div class="d-flex gap-1 justify-content-between" *ngIf="!isUpdating">
        <button type="button" class="btn btn-warning w-sm" (click)="onEdit($event)">
          <i class="ri-pencil-line align-bottom me-1"></i>
          {{ "EDIT" | translate }}
        </button>
      </div>

      <div class="d-flex gap-1 justify-content-between" *ngIf="isUpdating">
        <button type="button" class="btn btn-warning w-sm" (click)="onCancelEdit($event)">
            <i class="ri-arrow-go-back-line align-bottom me-1"></i>
            {{ 'CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-success w-sm">
          <i class="ri-save-line align-bottom me-1"></i>
          {{ "SAVE" | translate }}
        </button>
      </div>

    </div>

  </div>
  <!-- end col -->
</form>
